import dynamic from "next/dynamic";

export const ClientCard = dynamic(() => import("./component"));
